import {ObjectModelBuiltinPropertyType} from "~/enums/objectModelBuiltinPropertyType";
import {FormBuiltinType} from "~/enums/formBuiltinType";
import VisualizationBuilderModel from "~/models/tracked/visualizationBuilderModel";
import Guid from "~/helpers/guid";
import Visualization from "~/models/visualizations/visualization";
import VisualizationDataTableFilter from "~/models/visualizations/visualizationDataTableFilter";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";

export default class VisualizationDataTableFilterReference extends VisualizationBuilderModel {
  static repo: IRepo<VisualizationDataTableFilterReference> = new Repo<VisualizationDataTableFilterReference>('visualizationDataTableFilterReferences', VisualizationDataTableFilterReference, {});
  repo: IRepo<this>;

  source_client_id: string | null;
  element_client_id: string | null;
  data_fusion_point_client_id: string | null;
  object_model_builtin_type: ObjectModelBuiltinPropertyType | null;
  form_builtin_type: FormBuiltinType | null;

  constructor() {
    super();
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('source_client_id', null);
    this.defineProperty('element_client_id', null);
    this.defineProperty('data_fusion_point_client_id', null);
    this.defineProperty('object_model_builtin_type', null);
    this.defineProperty('form_builtin_type', null);
  }

  initialize(rootModel: Visualization, parent: VisualizationDataTableFilter, type: number, json: object = {}): this {
    this.rootModel = rootModel;
    this.parent = parent;

    this.loadFromJson(json);

    return this;
  }

  get rootName(): string {
    return 'filter_references';
  }

  addToRepo(): void {
    VisualizationDataTableFilterReference.repo.add(this);
  }
}